import React from 'react';
import { string } from 'prop-types';

import * as helpers from './helpers';

const StatisticsIcon = ({ color, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <g
      stroke={color}
      strokeWidth={1.5}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
    >
      <path d="M.75 10.3a7 7 0 0 1 7-7M7.75 17.3a7 7 0 0 1-7-7M14.75 10.3a7 7 0 0 1-7 7M17.188 10.188H7.75V.748a9.438 9.438 0 0 1 9.438 9.438z" />
    </g>
  </svg>
);

StatisticsIcon.propTypes = {
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

StatisticsIcon.defaultProps = {
  ...helpers.getDefaultIconDimensionsProps(18, 19),
};

export default StatisticsIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/statistics.js